module.exports = {
    label: {
        name:'Name',
        date: 'Date',
        scriptId: 'Script ID',
        header: 'Group Request Details',
        rejectHeader: 'Past Script Request Detail Test',
        patientName: 'Name of Patient',
        gender: 'Gender',
        dob: 'DOB',
        bloodGroup: 'Blood Group',
        phoneNumber: 'Phone Number',
        address: 'Address',
        namePharmacist: 'Name of Pharmacist',
        email: 'Email',
        status: 'Status',
        paidBy: 'Paid by',
        totalPrice: 'Total Price of Script',
        adminCommissionPercentage: 'Admin’s Commission Percentage',
        adminCommissionAmount: 'Admin’s Commission Amount',
        myAmount: 'My Amount',
        nodata: '----',
        copiedlink: 'Link copied Successfully!!',
        errorIncopyLink: 'Failed to copy link',
        idNumber: 'ID Number',
        patientMinor: 'Is Patient a Minor?',
        parentName: 'Name of Parent/Guardian',
        parentIDNumber: 'ID No. of Patient or Guardian',
//        medicineRequired: 'Medicine required',
        medicineRequired: 'Medication',
        specialInstructions: 'Special instructions/other',
        error: 'Something Went Wrong',
        prescription: 'Prescription',
        rejectRequest: 'Reject Request',
        reason: 'Reason',
        enterReason: 'Enter Reason',
        requestRejected: 'Group Request Rejected',
        height: 'Height',
        weight: 'Weight',
        bmi: 'BMI',
        pulse: 'Pulse',
        glucose: 'Glucose',
        smoker: 'Smoker',
        riskFactors: 'Risk Factors',
        bloodPressure: 'Blood Pressure',
        medication: 'Medication',
        nursingPractitioner: 'Nursing practitioner',
        clinicEmail: 'Clinic email',
        clinicName:'Clinic name',
        allergicTo:'Allergic to',
        patientImages:'Patient Images',
        notes: 'Notes',
        nursenotes:"Nurse Note",
        note: 'Note',
        nurseNote: 'Notes for nurse',
        noteRequired: 'Please enter note',
        reasonRequired: 'Please enter reason',
        enterNote: 'Enter Note',
        rejectReason: 'Reject Reason',
        placeholder: {
            enterName: 'Enter Name',
        },
        buttons: {
            copyScript: 'Copy Script Link',
            copyEScript: 'Copy eScript Link',
            shareScript: 'Share Script Via Email',
            shareEScript: 'Share eScript Via Email',
            reject: 'Reject',
            submit: 'Submit',
            sendNote: 'Send a note to nurse',
            createScriptModal: 'Create Script',
            createScript: "Create script / document",
            createEScript: "Create e-script / e-document",
            pastScript:"Past script /document",
            glp1History: "View GLP-1 history"
        }
    }
}
